import { render, staticRenderFns } from "./PageEditorAddContentOffcanvas.vue?vue&type=template&id=c4d168bc&scoped=true"
import script from "./PageEditorAddContentOffcanvas.vue?vue&type=script&lang=js"
export * from "./PageEditorAddContentOffcanvas.vue?vue&type=script&lang=js"
import style0 from "./PageEditorAddContentOffcanvas.vue?vue&type=style&index=0&id=c4d168bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4d168bc",
  null
  
)

export default component.exports